import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TimePeriod } from 'ngx-daterangepicker-material/daterangepicker.component';

import { Subscription } from 'rxjs';
import { AttributeData } from 'src/app/model';
import { ChartAttributes } from 'src/app/model/shared/components/entities/entities-profile/chart-builder';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from 'src/app/shared/services';

@Component({
  selector: 'app-attributes-charts',
  templateUrl: './attributes-charts.component.html',
  styleUrls: ['./attributes-charts.component.css']
})
export class AttributesChartsComponent implements OnInit, OnDestroy {
  @Input() entityData: any;
  @Input() attributeType: any;
  isLoader: boolean = false;
  selectedAttr: any;
  apiHitTime: Date;
  attributeData: any;
  statsSplit: any = [{ name: 'Current Value', value: '12' }, { name: 'Current Value', value: '12' }, { name: 'Current Value', value: '12' },
  { name: 'Current Value', value: '12' }];
  periodList: any = [{ id: 'today', name: 'Today' }, { id: '7days', name: 'Last 7 days' }, { id: '15days', name: 'Last 15 days' }];
  // old list commented
  // [{ id: 'today', name: 'Today' }, { id: '7days', name: 'Last 7 days' }, { id: 'thismonth', name: 'This month' }, { id: 'lastmonth', name: 'Last month' },
  // { id: '3months', name: 'Last 3 months' }, { id: '6months', name: 'Last 6 months' }];
  attributesList: any = [{ name: 'attr1', isSelected: true }, { name: 'attr2', isSelected: false }, { name: 'attr3', isSelected: false }, { name: 'attr5', isSelected: false }];
  period = new FormControl(this.periodList[0]);
  isTrend: boolean = false;
  trendAvailable: boolean = false;
  statisticsAttributeData: any = {};
  tenantGenericConfig: any;
  // Tab
  selectedTabIndex: number = 0;
  // plotChart: boolean = false;

  //BYC
  datesSelected: { from: Date, to: Date } = { from: null, to: null };
  domain = localStorage.getItem('domain') ?? '';

  private _tenantConfig: any;
  private _startTime: Date;
  private _endTime: Date;
  private _today: any = new Date();
  private _config: any = [];
  private _trendPlot: any = [];
  private _subscription: Subscription;
  private _getEntityAttributeSubscription: Subscription;
  private _getMappingDetailsSubscription: Subscription;
  private _getTrendSubscription: Subscription;

  public datepickerForm: FormGroup;
  public chartBuildForm: FormGroup;
  private _selectedDates = {
    from: null,
    to: null,
  };
  private _initializeForm(type: string = 'default') {
    this.datepickerForm = this._fb.group({
      thisdate: null
    });
  }
  private initialiseChartForm() {
    this.chartBuildForm = this._fb.group({
      xAxis: [null, [Validators.required]],
      yAxis: [null, [Validators.required]],
      yAxis2: [null],
      chartType: [null]
    });
  }

  chartBuilderFields : any ;

  constructor(public _service: ServicecallService, private _datePipe: DatePipe, private _dataSer: DataService, private _entityService: EntitiesServiceService, private _fb: FormBuilder) {
    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh' || res.name === 'trendUpdate') {
        this._getSelectedAttributeMapping();
      }
      if (res.name === 'requestChartData' && this.selectedTabIndex === 1) {
        this._dataSer.broadcast('plotChart', { 
          chartAttributes: this.chartBuildForm.value, 
          selectedDates: this.datesSelected 
        });
      }
    });
  }

  ngOnInit(): void {
    this.apiHitTime = new Date();
    this._config = this._service.getConfigurationBasedOnCategory(this.entityData) ? this._service.getConfigurationBasedOnCategory(this.entityData).threshold : [];
    this._tenantConfig = this._service.getConfigurationBasedOnCategory(this.entityData) ?
      this._service.getConfigurationBasedOnCategory(this.entityData) : [];
    this.chartBuilderFields = this._service.getConfigurationBasedOnCategory(this.entityData) ?
      this._service.getConfigurationBasedOnCategory(this.entityData)?.chartBuilderFields : [];
    this.tenantGenericConfig = this._service.getConfiguration('tenantGenericConfig') ?? null;
    if (this.attributeType === 'systemAttributes') {
      this.attributesList = this._tenantConfig?.systemAttributesChart?.length ? this._tenantConfig?.systemAttributesChart : [];
    } else {
      this.attributesList = this._tenantConfig?.attributesChart?.length ? this._tenantConfig?.attributesChart : [];
    }
    this.attributesList.map((elem: any) => elem.isSelected = false);
    if (this.attributesList?.length) {
      this.attributesList[0].isSelected = true;
    }
    this.statsSplit = this._tenantConfig?.attributesChartLegends?.length ? this._tenantConfig?.attributesChartLegends : [];
    this.selectedAttr = this.attributesList?.length ? this.attributesList[0] : null;
    this.periodList = this._tenantConfig?.tenant === 'TRL' ? [{ id: '15mins', name: 'Last 15 mins' }, { id: '30mins', name: 'Last 30 mins' },
    { id: '1hr', name: 'Last 1 hour' }] : this.periodList;
    this.period.setValue(this.periodList[0]);
    //Initializing Date-time range picker
    this._initializeForm();
    this.initialiseChartForm();
    const { startDate, endDate } = this.tenantGenericConfig?.defaultTimeRange
      ? this._service.calculateDateRange(this.tenantGenericConfig.defaultTimeRange)
      : { startDate: this._startTime, endDate: new Date() };

    this.datepickerForm.setValue({
      thisdate: { startDate, endDate }
    });
    if (this._service.getConfiguration('tenantGenericConfig').defaultTimeRange) {
      this._selectedDates = { from: startDate, to: endDate };
    }
    //Initializing Date-time range picker
    this.onPeriodFilterChange();
  }
  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._getEntityAttributeSubscription?.unsubscribe();
    this._getMappingDetailsSubscription?.unsubscribe();
    this._getTrendSubscription?.unsubscribe();
  }

  tabChanged(event: any) {
    this.selectedTabIndex = event.index;
    if(this.selectedTabIndex === 1){
      this._dataSer.broadcast('plotChart',{chartAttributes : this.chartBuildForm.value, selectedDates: this.datesSelected});
    }
  }

  onFormActionClick(event: any) {
    // this.plotChart = true;
    this._dataSer.broadcast('plotChart',{chartAttributes : this.chartBuildForm.value, selectedDates: this.datesSelected});
  }

  onFormActionClear() {
    this.chartBuildForm?.reset();
  }


  onAttrSelect(index: number) {
    if (!this.attributesList[index].isSelected) {
      this.attributesList.map((elem: any) => elem.isSelected = false);
      this.attributesList[index].isSelected = !this.attributesList[index]?.isSelected;
      this.selectedAttr = this.attributesList[index];
      this.isTrend = false;
      this._getSelectedAttributeMapping();
    }
  }

  onPeriodFilterChange() {
    this._endTime = null;
    switch (this.period?.value?.id) {
      case 'today':
        this._startTime = new Date(this._today.getFullYear(), this._today.getMonth(), this._today.getDate(), 0, 0, 0, 999);
        break;
      case '7days':
        this._startTime = new Date(this._today.getFullYear(), this._today.getMonth(), this._today.getDate() - 7, 0, 0, 0, 999);
        break;
      case '15days':
        this._startTime = new Date(this._today.getFullYear(), this._today.getMonth(), this._today.getDate() - 15, 0, 0, 0, 999);
        break;
      case 'thismonth':
        this._startTime = new Date(this._today.getFullYear(), this._today.getMonth(), 1, 0, 0, 0, 999);
        break;
      case 'lastmonth':
        this._startTime = new Date(this._today.getFullYear(), this._today.getMonth() - 1, 1, 0, 0, 0, 999);
        this._endTime = new Date(new Date().getFullYear(), new Date().getMonth(), 0, 23, 59, 59, 999);
        break;
      case '3months':
        this._startTime = new Date(this._today.getFullYear(), this._today.getMonth() - 3, 1, 0, 0, 0, 999);
        break;
      case '6months':
        this._startTime = new Date(this._today.getFullYear(), this._today.getMonth() - 6, 1, 0, 0, 0, 999);
        break;
      case '15mins':
        this._startTime = new Date(new Date().setMinutes(new Date().getMinutes() - 15));
        break;
      case '30mins':
        this._startTime = new Date(new Date().setMinutes(new Date().getMinutes() - 30));
        break;
      case '1hr':
        this._startTime = new Date(new Date().setMinutes(new Date().getMinutes() - 60));
        break;
    }
    this._getSelectedAttributeMapping();
  }

  /**
   * Saves time
   * @param [data] 
   */
  saveTime(data?: any) {
    if (data) {
      let dateRange: TimePeriod = data;
      const offsetTime = new Date().getTimezoneOffset() * 60 * 1000;
      this._selectedDates.from = this._getTimestampInMillisecond(dateRange?.startDate?.toDate()) + (offsetTime)
      this._selectedDates.to = this._getTimestampInMillisecond(dateRange?.endDate?.toDate()) + (offsetTime)
      this.datepickerForm.setValue({
        thisdate: { startDate: this._selectedDates.from, endDate: this._selectedDates.to }
      });
    }
    this._getSelectedAttributeMapping();
    this.datesSelected.from = this._selectedDates.from;
    this.datesSelected.to = this._selectedDates.to;
    this._dataSer.broadcast('plotChart',{chartAttributes : this.chartBuildForm.value, selectedDates: this.datesSelected})
  }

  private _getTimestampInMillisecond(date: Date): number {
    return date ? new Date(date)?.getTime() : 0;
  }

  /**
   * Datas zoom
   * @param event 
   */
  dataZoom(event: AttributeData) {
    this.attributeData = event;
    this._plotAttributeGraph();
  }

  private _getSelectedAttributeMapping() {
    const payloadData = {
      type: 4,
      siteId: this.entityData?.site?._id,
      entityId: this.entityData?._id,
      attribute: this.selectedAttr?.name ? this.selectedAttr?.name : undefined,
      isNoLoader: true
    };
    this.isLoader = true;
    this._getMappingDetailsSubscription = this._entityService.getMappingDetails(payloadData).subscribe({
      next: (res: any) => {
        if (res?.length && res?.[0]?.attributes?.length && res?.[0]?.attributes?.[0]?.trend?.length) {
          if (res?.[0]?.attributes?.[0]?.trend?.some((item: any) => item?.value)) {
            this.trendAvailable = true;
            this._getTrend();
          } else {
            this.trendAvailable = false;
          }
        } else {
          this.trendAvailable = false;
        }
        if (!this.trendAvailable)
          this._getAttributeDetails();
      },
      error: () => {
        this._getAttributeDetails();
      }
    });
  }

  private _getTrend() {
    if (!this.isLoader)
      this.isLoader = true;
    this._getTrendSubscription = this._service.getTrend(this._getRequestData()).subscribe({
      next: (resp: any) => {
        if (Object.values(resp)?.length)
          this._trendPlot = resp?.[this.selectedAttr?.name];
        this._getAttributeDetails();
      },
      error: () => {
        this._trendPlot = [];
        this._getAttributeDetails();
      }
    })
  }

  private _getRequestData() {
    this.datesSelected.from = this._selectedDates?.from ?? this._startTime;
    this.datesSelected.to = this._selectedDates?.to ?? (this._endTime ? this._endTime : Date.now());
    return {
      entityId: this.entityData?._id,
      from: this._datePipe.transform(this._selectedDates?.from ?? this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this._selectedDates?.to ?? (this._endTime ? this._endTime : Date.now()), 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this._service.getSiteId(),
      attributes: this.selectedAttr?.name ? [this.selectedAttr?.name] : undefined,
      includeHistory: false
    };
  }

  private _getAttributeDetails() {
    this.apiHitTime = new Date();
    this._getEntityAttributeSubscription = this._service.getEntityAttribute(this._getRequestData()).subscribe({
      next: (resp: any) => {
        if (resp?.status) {
          if (resp?.response?.data) {
            this.attributeData = resp?.response?.data?.attributes;
            if (Object.keys(this.attributeData).length) {
              this._plotAttributeGraph();
            } else {
              this.attributeData = {};
              this.statisticsAttributeData = {};
            }
          } else {
            this.attributeData = {};
            this.statisticsAttributeData = {};
          }
        }
        this.isLoader = false;
      },
      error: () => {
        this.isLoader = false;
        this.attributeData = [];
        this.statisticsAttributeData = {};
      }
    })
  }

  private _plotAttributeGraph() {
    Object.keys(this.attributeData).forEach(element => {
      const attributeAlertLine = { showAttributeLowerLine: false, showAttributeUpperLine: false };
      const windowAlertLine = { showWindowLowerLine: false, showWindowUpperLine: false };
      const attributeDeviceLine = { deviceAttributeLowerLine: false, deviceAttributeUpperLine: false };
      const windowDeviceLine = { deviceWindowLowerLine: false, deviceWindowUpperLine: false };
      this.attributeData[element].map((item: any) => { item.value = parseFloat(item.value); item.windowAvg ? item.windowAvg = parseFloat(item.windowAvg) : undefined })
      this.statisticsAttributeData = {};
      const maxValue = Math.max(...this.attributeData[element].map(({ value }) => value));
      const minValue = Math.min(...this.attributeData[element].map(({ value }) => value));
      let sumValue: any = 0;
      let meanValue: any;
      let invalidPointCount: any = 0;
      this.attributeData[element].map(({ value }) => value).forEach(value => {
        sumValue += parseFloat(value);
      });
      meanValue = sumValue / (this.attributeData[element].map(({ value }) => value)).length;
      const statistics = {
        mean: Math.round(meanValue * 100) / 100, largest: maxValue, lowest: minValue,
        upperAlertThreshold: null, lowerAlertThreshold: null
      };
      let attributeBarData2 = {};
      let attributeBarData3 = {};
      let attributeBarData4 = {};
      const attributeThresholdData = {};
      const attributeBarData = {
        x: this.attributeData[element].map(({ timestamp }) => new Date(timestamp)),
        y: this.attributeData[element].map(({ value }) => value),
        mode: 'lines+markers+text',
        connectgaps: true,
        title: '',
        tabTitle: '',
        margin: { l: 30, r: 10, b: 15, t: 0 },
        width: 900,
        height: 380,
        barColor: 'white',
        name: 'Instantaneous Data',
        legend: this.entityData?.category !== 'patient' ? true : false,
        hovertemplate: '',
        opacity: 1.0,
        line: {
          color: 'rgb(169, 169, 169)'
        },
        textfont: { size: [] },
        marker: { color: '#097969', size: 4 },
        annotations: this.entityData?.category !== 'patient' ? [
          {
            x: new Date((this.attributeData[element].find(element1 => element1.value === maxValue))?.timestamp),
            y: maxValue,
            xref: "x",
            yref: "y",
            text: "Max value=" + (Math.round(maxValue * 100) / 100)?.toString(),
            showarrow: true,
            font: {
              family: "Inter",
              size: 12,
              color: "#ffffff"
            },
            align: "center",
            arrowhead: 7,
            // arrowsize: 0.5,
            // arrowwidth: 2,
            arrowcolor: "#58B19F",
            ax: 20,
            ay: -30,
            // bordercolor: "#c7c7c7",
            // borderwidth: 2,
            borderpad: 4,
            bgcolor: "#58B19F",
            opacity: 0.8
          },
          {
            x: new Date((this.attributeData[element].find(element1 => element1.value === minValue))?.timestamp),
            y: minValue,
            xref: "x",
            yref: "y",
            text: "Min value=" + (Math.round(minValue * 100) / 100)?.toString(),
            showarrow: true,
            font: {
              family: "Inter",
              size: 12,
              color: "#ffffff"
            },
            align: "center",
            arrowhead: 7,
            // arrowsize: 0.5,
            // arrowwidth: 2,
            arrowcolor: "#58B19F",
            ax: 20,
            ay: -30,
            // bordercolor: "#c7c7c7",
            // borderwidth: 2,
            borderpad: 4,
            bgcolor: "#58B19F",
            opacity: 0.8
          }
        ] : []
      };
      attributeBarData.tabTitle = element;
      this.statisticsAttributeData.attributeData = [];
      const notes = this.attributeData[element].map((item: any) => item.notes ? '<span style="color:#01908E;font-size: 25px;width:100%;">%{y}</span>,  %{x}<br><span style="font-size: 15px;">Notes:</span><br><b>' + item?.notes?.value + '</b><br> <br>Last Updated By: <b>' + item?.notes?.author + '</b><br>' + this._datePipe.transform(item?.notes?.timestamp, 'MMM d, y, h:mm:ss a') + '<extra></extra>' :
        '<span style="color:#01908E;">%{y}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;%{x}  <br><br> <extra></extra>');
      const text = this.attributeData[element].map((item: any) => item.notes ? '📋' : '');
      const textposition = this.attributeData[element].map((item: any) => item.notes ? 'top' : '');
      const textSize = this.attributeData[element].map((item: any) => item.notes ? '16' : '');
      if (this.attributeData[element].every((item: any) => item.windowAvg) && this.entityData?.category !== 'patient') {
        attributeBarData2 = {
          x: this.attributeData[element].map(({ timestamp }) => new Date(timestamp)),
          y: this.attributeData[element].map(({ windowAvg }) => windowAvg),
          mode: 'lines+markers+text',
          connectgaps: true,
          title: '',
          margin: { l: 30, r: 10, b: 15, t: 0 },
          hovertemplate: '',
          width: 700,
          barColor: 'white',
          name: 'Simple Moving Average',
          line: {
            color: '#44BFCA'
          },
          marker: { color: '#097969', size: 4 },
        }
        attributeBarData2['hovertemplate'] = notes;
        attributeBarData2['text'] = text;
        attributeBarData2['textposition'] = textposition;
      }
      let absoluteTrendData;
      let rateTrendData;
      if (this._trendPlot && this.isTrend) {
        // Object.keys(this._trendPlot).forEach(ele => {
        // if (ele) {
        // absoluteTrendData = this._trendPlot?.[ele].find(e => e?.trend === 'absolute');
        // rateTrendData = this._trendPlot?.[ele].find(e => e?.trend === 'rate');
        // statistics['showTrend'] = (absoluteTrendData?.showTrend || rateTrendData?.showTrend) ? true : false;
        // statistics['showHistory'] = (absoluteTrendData?.showHistory || rateTrendData?.showHistory) ? true : false;
        absoluteTrendData = this._trendPlot.find(data => data?.trend === 'absolute');
        rateTrendData = this._trendPlot.find(data => data?.trend === 'rate');
        if (absoluteTrendData) {
          attributeBarData3 = {
            x: absoluteTrendData?.plot.map(({ timestamp }) => new Date(timestamp)),
            y: absoluteTrendData?.plot.map(({ value }) => value),
            mode: 'lines+markers+text',
            connectgaps: true,
            title: '',
            margin: { l: 30, r: 10, b: 15, t: 0 },
            hovertemplate: '',
            width: 700,
            barColor: 'white',
            name: 'Trend-absolute',
            line: {
              color: '#FFBF51',
              dash: 'dot'
            },
            marker: { color: '#FF8C00', size: 20 },
          }
          statistics['absoluteTrendType'] = absoluteTrendData?.type;
          statistics['absoluteTrendPercentage'] = absoluteTrendData?.slopeValue;
          statistics['absoluteLastProcessedTimestamp'] = absoluteTrendData?.lastProcessedTimestamp;
          statistics['absoluteWindowSize'] = (this._subtractTime(new Date(absoluteTrendData?.lastProcessedTimestamp), absoluteTrendData?.windowSize))?.toISOString();
          attributeBarData3['hovertemplate'] = notes;
          attributeBarData3['text'] = text;
          attributeBarData3['textposition'] = textposition;
        }
        if (rateTrendData) {
          attributeBarData4 = {
            x: rateTrendData?.plot.map(({ timestamp }) => new Date(timestamp)),
            y: rateTrendData?.plot.map(({ value }) => value),
            mode: 'lines+markers+text',
            connectgaps: true,
            title: '',
            margin: { l: 30, r: 10, b: 15, t: 0 },
            hovertemplate: '',
            width: 700,
            barColor: 'white',
            name: 'Trend -rate',
            line: {
              color: '#7C83D0',
              dash: 'dot'
            },
            marker: { color: '#6495ED', size: 4 },
          }
          statistics['rateTrendType'] = rateTrendData?.type;
          statistics['rateTrendPercentage'] = rateTrendData?.slopeValue;
          statistics['rateLastProcessedTimestamp'] = rateTrendData?.lastProcessedTimestamp;
          statistics['rateWindowSize'] = (this._subtractTime(new Date(rateTrendData?.lastProcessedTimestamp), rateTrendData?.windowSize))?.toISOString();
          attributeBarData4['hovertemplate'] = notes;
          attributeBarData4['text'] = text;
          attributeBarData4['textposition'] = textposition;
        }
        // }
        // })
      }
      attributeBarData['hovertemplate'] = notes;
      attributeBarData['text'] = text;
      attributeBarData['textposition'] = textposition;
      attributeBarData['textfont']['size'] = textSize;
      if (this._config?.length) {
        const threshold = this._config.find((item: any) => item?.name?.toLowerCase() === element?.toLowerCase());
        if (threshold && Object.keys(threshold)?.length) {
          const lowerAlertThreshold = threshold.alertThreshold?.find((lower: any) => lower.name === 'lower');
          const upperAlertThreshold = threshold.alertThreshold?.find((upper: any) => upper.name === 'upper');
          const lowerDeviceThreshold = threshold.deviceThreshold?.find((lower: any) => lower.name === 'lower');
          const upperDeviceThreshold = threshold.deviceThreshold?.find((upper: any) => upper.name === 'upper');
          statistics['upperAlertThreshold'] = upperAlertThreshold?.threshold;
          statistics['lowerAlertThreshold'] = lowerAlertThreshold?.threshold;
          attributeBarData['marker'] = {
            color: this.attributeData[element].map((item: any) => {
              if (item.value <= +lowerAlertThreshold?.threshold) {
                attributeAlertLine.showAttributeLowerLine = true;
              }
              if (item.value >= +upperAlertThreshold?.threshold) {
                attributeAlertLine.showAttributeUpperLine = true;
              }
              if (item.value <= +lowerDeviceThreshold?.threshold) {
                attributeDeviceLine.deviceAttributeLowerLine = true;
              }
              if (item.value >= +upperDeviceThreshold?.threshold) {
                attributeDeviceLine.deviceAttributeUpperLine = true;
              }
              if (item.value >= +lowerAlertThreshold?.threshold && item.value <= +upperAlertThreshold?.threshold) {
                return '#097969';
              }
              else {
                invalidPointCount += 1;
                return '#D10000';
              }
            }),
            size: this.attributeData[element].map((item: any) => {
              if (item.value >= +lowerAlertThreshold?.threshold && item.value <= +upperAlertThreshold?.threshold) {
                return 4;
              }
              else {
                return 8;
              }
            })
          };
          if (attributeBarData2 && Object.keys(attributeBarData2)?.length) {
            attributeBarData2['marker'] = {
              color: this.attributeData[element].map((item: any) => {
                if (item.value <= +lowerAlertThreshold?.threshold) {
                  windowAlertLine.showWindowLowerLine = true;
                }
                if (item.value >= +upperAlertThreshold?.threshold) {
                  windowAlertLine.showWindowUpperLine = true;
                }
                if (item.value <= +lowerDeviceThreshold?.threshold) {
                  windowDeviceLine.deviceWindowLowerLine = true;
                }
                if (item.value >= +upperDeviceThreshold?.threshold) {
                  windowDeviceLine.deviceWindowUpperLine = true;
                }
                if (item.value >= +lowerAlertThreshold?.threshold && item.value <= +upperAlertThreshold?.threshold) {
                  return '#097969'
                }
                else {
                  return '#D10000'
                }
              }),
              size: this.attributeData[element].map((item: any) => {
                if (item.value >= +lowerAlertThreshold?.threshold && item.value <= +upperAlertThreshold?.threshold) {
                  return 4;
                }
                else {
                  return 8;
                }
              })
            };
          }
          if (lowerAlertThreshold && upperAlertThreshold) {
            attributeThresholdData['attributeThresholdMarker'] = {
              color: upperAlertThreshold?.colour,
              upper: +upperAlertThreshold?.threshold,
              lower: +lowerAlertThreshold?.threshold,
              showAttributeLowerLine: attributeAlertLine?.showAttributeLowerLine,
              showAttributeUpperLine: attributeAlertLine?.showAttributeUpperLine,
              showWindowLowerLine: windowAlertLine?.showWindowLowerLine,
              showWindowUpperLine: windowAlertLine?.showWindowUpperLine
            }
          }

          if (lowerDeviceThreshold && upperDeviceThreshold) {
            attributeThresholdData['deviceThresholdMarker'] = {
              color: upperDeviceThreshold?.colour,
              upper: +upperDeviceThreshold?.threshold,
              lower: +lowerDeviceThreshold?.threshold,
              deviceAttributeLowerLine: attributeDeviceLine.deviceAttributeLowerLine,
              deviceAttributeUpperLine: attributeDeviceLine.deviceAttributeUpperLine,
              deviceWindowLowerLine: windowDeviceLine.deviceWindowLowerLine,
              deviceWindowUpperLine: windowDeviceLine.deviceWindowUpperLine
            }
          }

        }
      }
      this.statisticsAttributeData.attributeData.push(attributeBarData);
      if (attributeBarData2 && Object.keys(attributeBarData2)?.length) {
        this.statisticsAttributeData.attributeData.push(attributeBarData2);
      }
      if (attributeBarData3 && Object.keys(attributeBarData3)?.length) {
        const lastCriticalValue = absoluteTrendData?.plot?.findLast((ele) => ele.type === 'critical');
        if (absoluteTrendData?.plot?.length > 0) {
          attributeBarData3['marker'] = {
            color: absoluteTrendData?.plot?.map((item: any) => {
              if (item === lastCriticalValue) {
                return '#a11f1f';
              } else {
                return '#FFBF51';
              }
            }),
            size: absoluteTrendData?.plot?.map((item: any) => {
              if (item === lastCriticalValue) {
                return 18;
              }
              else {
                return 8;
              }
            })
          }
        }
        if (lastCriticalValue) {
          attributeBarData3['annotations'] = [
            {
              x: new Date(lastCriticalValue?.timestamp),
              y: lastCriticalValue?.value,
              xref: "x",
              yref: "y",
              text: "Critical value=" + lastCriticalValue?.value.toString(),
              showarrow: true,
              font: {
                family: "Inter",
                size: 14,
                color: "#ffffff"
              },
              align: "center",
              arrowhead: 7,
              // arrowsize: 1,
              // arrowwidth: 2,
              arrowcolor: "#FF0000",
              ax: 20,
              ay: -30,
              // bordercolor: "#c7c7c7",
              // borderwidth: 2,
              borderpad: 4,
              bgcolor: "#FF0000",
              opacity: 0.8
            },
          ]
        }
        this.statisticsAttributeData.attributeData.push(attributeBarData3);
      }
      if (attributeBarData4 && Object.keys(attributeBarData4)?.length) {
        const finalCriticalValue = rateTrendData?.plot?.findLast((ele) => ele.type === 'critical');
        if (rateTrendData?.plot?.length > 0) {
          attributeBarData4['marker'] = {
            color: rateTrendData?.plot?.map((item: any) => {
              if (item === finalCriticalValue) {
                return '#a11f1f';
              } else {
                return '#7C83D0';
              }
            }),
            size: rateTrendData?.plot?.map((item: any) => {
              if (item === finalCriticalValue) {
                return 18;
              }
              else {
                return 8;
              }
            })
          }
        }
        if (finalCriticalValue) {
          attributeBarData4['annotations'] = [
            {
              x: new Date(finalCriticalValue?.timestamp),
              y: finalCriticalValue?.value,
              xref: "x",
              yref: "y",
              text: "Critical value=" + finalCriticalValue?.value.toString(),
              showarrow: true,
              font: {
                family: "Inter",
                size: 14,
                color: "#ffffff"
              },
              align: "center",
              arrowhead: 7,
              // arrowsize: 1,
              // arrowwidth: 2,
              arrowcolor: "#FF0000",
              ax: 20,
              ay: -30,
              // bordercolor: "#c7c7c7",
              // borderwidth: 2,
              borderpad: 4,
              bgcolor: "#FF0000",
              opacity: 0.8
            },
          ]
        }
        this.statisticsAttributeData.attributeData.push(attributeBarData4);
      }
      if (attributeThresholdData && Object.keys(attributeThresholdData)?.length) {
        this.statisticsAttributeData.attributeData.push(attributeThresholdData);
      }
      statistics['invalidPointCount'] = invalidPointCount;
      statistics['windowAverage'] = Math.round((this.attributeData[element][0].windowAvg) * 100) / 100;
      statistics['currentValue'] = this.attributeData[element].map(({ value }) => value)[0];
      // this.statisticsAttributeData.statisticsData = statistics;
      // this.statisticsAttributeData.windowAverage = Math.round((this.attributeData[element][0].windowAvg) * 100) / 100;
      // this.statisticsAttributeData.currentValue = this.attributeData[element].map(({ value }) => value)[0];
      // this.attributeDataList.push(this.statisticsAttributeData);
      Object.keys(statistics)?.forEach((elem: any) => {
        this.statsSplit?.map((item: any) => {
          if (elem === item?.key) {
            item['value'] = statistics[elem];
          }
        });
      });

    });
  }

  private _subtractTime(date, window) {
    const hour = date?.getHours() - window?.split(':')?.[0];
    const min = date?.getMinutes() - window?.split(':')?.[1];
    const sec = date?.getSeconds() - window?.split(':')?.[2];
    date?.setHours(hour);
    date?.setMinutes(min);
    date?.setSeconds(sec);
    return date;
  }

  onTrendChange() {
    this.isTrend = !this.isTrend;
    if (!this.isTrend)
      this._getAttributeDetails();
    else
      this._getTrend();
  }

  formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const formattedDate = date.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', month: 'short', day: '2-digit', year: 'numeric' });
    return formattedDate
  }

}
